<template>
  <div
    class="z-50 flex items-center justify-center bg-white space-x-3"
    :class="{
      'fixed w-screen h-screen': !isNested,
      'absolute left-0 top-0 w-full h-full': isNested,
    }"
  >
    <div class="w-4 h-4 bg-core rounded-full animate-bounce"></div>
    <div
      class="animation-delay-75 w-4 h-4 bg-core rounded-full animate-bounce"
    ></div>
    <div
      class="animation-delay-150 w-4 h-4 bg-core rounded-full animate-bounce"
    ></div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'dn-loader',
})
export default class Loader extends Vue {
  @Prop({ type: Boolean, default: false }) isNested!: boolean;
}
</script>
